export default "__VITE_ASSET__0a61165e__"